export const navigationIreland = {
  enter_your_postcode: 'Enter Your Eircode',
  postcode_hint: "Full valid Eircode, e.g. 'A65 F4E2'",
  issue_with_postcode:
    'There was a problem finding your Eircode. Please try again.',
  new_postcode: 'Change Eircode',
  postcode: 'Eircode',
}
